<script lang="ts">
  import Label from '$provider/constants/Label';
  import { ListAlertType } from '../ListAlertProps';
  import AlertView from './AlertView.svelte';
  import AlertText from './AlertText.svelte';
  import ToggleAction from './ToggleAction.svelte';
  import EditableListRow from '$shared/molecules/EditableListRow/EditableListRow.svelte';
  import Icon from '$shared/atoms/Icon/Icon.svelte';
import { IconType } from '$shared/constants/IconType';
  import type { DataListAlert } from '$provider/models/datalist/DataListAlert';

  interface Props {
    alert: DataListAlert;
    onevent?: (payload: { type: string; data: any }) => void;
  }

  let { alert, onevent }: Props = $props();

  const onClickTrash = (): void => {
    onevent?.({ type: 'click-delete', data: alert });
  };
</script>

<AlertView type={ListAlertType.Added} key={Label.Add} icon="icon-corner-down-right">
  {#snippet value()}
    <div  class="value" class:non-editable={!alert?.isEditable}>
      <EditableListRow active={alert?.isEditable} option={alert?.editableRow} {onevent}>
        <AlertText {alert} />
      </EditableListRow>
    </div>
  {/snippet}

  {#if alert?.isNewlyAdded}
    <div class="trash-action">
      <Icon value="icon-trash" type={IconType.Button} onclick={onClickTrash} />
    </div>
  {:else if alert?.showToggleAction}
    <ToggleAction {alert} {onevent} />
  {/if}
</AlertView>

<style>
  .value {
    width: 100%;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    padding: 8px 14px;
  }
  .value.non-editable {
    height: inherit;
    display: flex;
    align-items: center;
  }
  .trash-action {
    margin-right: 20px;
    margin-top: 12px;
  }
</style>
